// React
import React from 'react'
import PropTypes from 'prop-types'

// Appt
import Box from '../../simple/box/Box.js'
import Text from '../../simple/text/Text.js'

// Font Awesome
import styled from 'styled-components'

/**
 * `ActionBoxLarge` renders a Card to display a counter of items eg. number of posts
 */


const StyledBox = styled(Box)`
  border: 2px solid #04124C;
  &:hover {
      border: 2px solid #ff8300;
  }
`

const StyledText = styled(Text)`
  text-decoration: none;

  .action-box-large:hover &, &:focus, &:hover, &:visited, &:link, &:active, &:is(:hover) {
      text-decoration: none;
      color: #ff8300 !important;
  }

  &:hover:not(:first-child) {
    // background: #c34a36;
  }
`

class ActionBoxLarge extends React.Component {

  render () {


    return (
       <StyledBox 
            background='primary' 
            onClick={() => this.props?.onClick()}
            margin="xsmall"
            pad="small"
            round="small"
            animation='fadeIn'
            hoverIndicator={{ 
                color: 'besmartBlue', cursor: 'pointer'
            }}
            className="action-box-large"
        >
        <Box height="125px" align="center" justify="center" >
            <StyledText 
                size="large" 
                weight="bold" 
                textStyle={{ underline: 'none' }} 
                textAlign="center" 
                color='besmartBlue'
            >
                {this.props?.title}
            </StyledText>
        <StyledText textStyle={{ underline: 'none' }} textAlign="center" color='besmartBlue'>{this.props?.description}</StyledText>
        </Box>
    </StyledBox> 
    
    )
  }
}


ActionBoxLarge.propTypes = {
  /** 
   * The title for the card
   */
  title: PropTypes.string,
  /** 
   * The title for the card
   */
  description: PropTypes.string,
  /**
   * A large sized number displayed in the card
   */
  onClick: PropTypes.func,
  /**
   * The icon displayed on the card
   */
}


export default ActionBoxLarge
